import React, {Fragment, useCallback} from "react";
import {Col, FormGroup, ModalBody, ModalFooter, Row} from "reactstrap";
import ZeusButton from "../../../components/Button";
import InputCreator from "../../../components/Forms/components/InputCreator";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import ToggleCreator from "../../../components/Forms/components/ToggleCreator";
import TreeSelector from "../../../components/Forms/components/TreeSelector";
import {useFetchEventRules} from "../eventRulesTable/useEventRulesTableData";
import {useFormData} from "./useFormData";
import {CONDITIONS_HELP} from "./constants";

const EventRuleForm = (props) => {
  const {data, onCancel} = props;
  const {refetch} = useFetchEventRules();
  const callback = useCallback(() => {
    onCancel();
    refetch();
  }, [onCancel, refetch]);
  const {
    applianceOptions,
    conditionsError,
    contentTypeOptions,
    eventTypeOptions,
    formData,
    handleChange,
    handleScopeChange,
    handleSubmit,
    handleToggleEnabled,
    isActive,
    mode,
    scopeOptions,
    webhookOptions,
  } = useFormData(data, callback);

  const {
    appliances = [],
    conditions,
    description,
    enabled,
    event_types = [],
    name,
    object_types = [],
    scope = [],
    webhook,
  } = formData;

  // `mode` and `isActive` come from the hook so render and submit logic stay in sync.
  const isRequired = (field) => mode.required.includes(field);

  return (
    <Fragment>
      <ModalBody>
        <Row>
          <InputCreator
            data-cy="name"
            isRequired
            inSingleRow
            label="Name"
            large
            name="name"
            onChange={handleChange}
            value={name}
          />
          <InputCreator
            data-cy="description"
            inSingleRow
            label="Description"
            large
            name="description"
            onChange={handleChange}
            value={description}
          />
          <SelectCreator
            classNamePrefix="event-types"
            id="event-types"
            isRequired
            isMulti
            inSingleRow
            label="Event types"
            large
            name="event_types"
            onChange={handleChange}
            options={eventTypeOptions}
            value={event_types}
          />

          {isActive("scope") && (
            <Col xs="12">
              <FormGroup row>
                <Col md="3">
                  <label className="form-control-label roboto-bold" htmlFor="scope">
                    Scope
                  </label>
                </Col>
                <Col xs="9">
                  <TreeSelector
                    isRequired={isRequired("scope")}
                    defaultValue={scope}
                    options={scopeOptions}
                    onChange={handleScopeChange}
                    childrenKey="locations"
                    id="scope"
                    classNamePrefix="scope"
                  />
                </Col>
              </FormGroup>
            </Col>
          )}

          {isActive("appliances") && (
            <SelectCreator
              classNamePrefix="appliances"
              id="appliances"
              inSingleRow
              isMulti
              isRequired={isRequired("appliances")}
              label="Appliances"
              large
              name="appliances"
              onChange={handleChange}
              options={applianceOptions}
              value={appliances}
            />
          )}

          {isActive("object_types") && (
            <SelectCreator
              classNamePrefix="object-types"
              id="object-types"
              isMulti
              isRequired={isRequired("object_types")}
              inSingleRow
              label="Object types"
              large
              name="object_types"
              onChange={handleChange}
              options={contentTypeOptions}
              value={object_types}
            />
          )}

          <ToggleCreator
            data-cy="enabled"
            inSingleRow
            checked={enabled}
            label="Enabled"
            large
            onChange={handleToggleEnabled}
          />

          {isActive("conditions") && (
            <InputCreator
              data-cy="conditions"
              description={CONDITIONS_HELP}
              error={conditionsError}
              inSingleRow
              label="Conditions"
              large
              name="conditions"
              placeholder='{"attr": "name", "value": "DM-Buffalo", "op": "eq"}'
              type="textarea"
              onChange={handleChange}
              value={conditions}
            />
          )}

          <SelectCreator
            classNamePrefix="webhook"
            id="webhook"
            isRequired
            inSingleRow
            label="Webhook"
            large
            name="webhook"
            onChange={handleChange}
            options={webhookOptions}
            value={webhook}
          />
        </Row>
      </ModalBody>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={handleSubmit}>
          SAVE
        </ZeusButton>
        <ZeusButton data-cy="cancel-btn" onClick={onCancel} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </Fragment>
  );
};

export default EventRuleForm;
